import React from 'react';
import { PreviewButton, Tooltip } from 'components';
import NoAccessAlert from '@app/listing/alerts/NoAccessAlert';
import type { RootScopeType } from '@app/caferealtor/Default.controller';
import {
  isLimitedAccessOnNonActiveBrokerage,
  isLimitedAccessOnUnclaimedBrokerage,
} from 'utils';
import { Listing } from 'api/ListingController/getListing';

interface OfferMessageProps {
  listingLink: string;
  listing: Listing;
  listingId: string;
  onSend: () => Promise<void>;
  sendButtonDisabled: boolean;
  $rootScope: RootScopeType;
  ModalService: any;
}

function OfferMessageHeader({
  listing,
  listingId,
  listingLink,
  onSend,
  sendButtonDisabled,
  $rootScope,
  ModalService,
}: OfferMessageProps) {
  const isLimitedAccessUnclaimed = isLimitedAccessOnUnclaimedBrokerage(
    $rootScope.auth,
    $rootScope.orgStatus,
    $rootScope.currentPlan,
  );
  const isLimitedAccessNonActive = isLimitedAccessOnNonActiveBrokerage(
    $rootScope.auth,
    $rootScope.orgStatus,
    $rootScope.currentPlan,
  );

  return (
    <div className="normalheader transition animated fadeIn">
      <div className="hpanel">
        {isLimitedAccessUnclaimed && <NoAccessAlert />}
        <div className="panel-body">
          <h2 className="font-light m-b-xs">
            <div className="col-md-8">
              <a
                className="listing-link"
                href={listingLink}
                data-cy="listing-link"
              >
                {listing.line1} {listing.line2 || ''}
              </a>
              - Message Showing Agents
            </div>
            <div className="col-md-4">
              <a
                className={`pull-right btn btn-default margin-right ${
                  isLimitedAccessUnclaimed ? 'disabled' : ''
                }`}
                href={`#/listing/${listingId}/view`}
                data-cy="cancel"
              >
                Cancel
              </a>
              <button
                className="pull-right btn btn-primary margin-right"
                onClick={onSend}
                disabled={sendButtonDisabled}
                data-cy="send"
              >
                Send
              </button>
              <Tooltip
                title={
                  isLimitedAccessNonActive &&
                  'You cannot view this modal as this listing is not represented by BrokerBay.'
                }
              >
                <div className="pull-right">
                  <PreviewButton
                    listing={listing}
                    listingId={listingId}
                    isDisabled={isLimitedAccessNonActive}
                    angularInput={{
                      $rootScope,
                      ModalService,
                    }}
                    isBorderLess
                  />
                </div>
              </Tooltip>
            </div>
          </h2>
        </div>
      </div>
    </div>
  );
}

export default OfferMessageHeader;
